import { useState, useEffect } from 'react';

export default function Hero() {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const heroImages = [
    'https://public.readdy.ai/ai/img_res/05f1b379346529a42095e98d83badf74.jpg',
    'https://readdy.ai/api/search-image?query=Premium%20VE%20Goodies%20branded%20vending%20machine%20featuring%20large%20orange%20swirl%20logo%20with%20green%20leaves%2C%20multiethnic%20office%20workers%20including%20White%20man%20with%20brown%20hair%2C%20Black%20woman%2C%20Asian%20woman%2C%20Hispanic%20man%2C%20and%20Caucasian%20redhead%20woman%20choosing%20fresh%20beverages%20together%20in%20modern%20workplace%20cafeteria%2C%20diverse%20team%20members%20from%20all%20backgrounds%20interacting%20happily%2C%20bright%20professional%20setting%20with%20orange%20and%20white%20color%20scheme%2C%20contemporary%20business%20environment%20with%20polished%20design%2C%20minimalist%20clean%20background&width=1920&height=1080&seq=hero-truly-diverse-vegoodies-logo-102&orientation=landscape',
    'https://readdy.ai/api/search-image?query=State-of-the-art%20vending%20machine%20with%20VE%20Goodies%20VENDING%20text%20and%20orange%20logo%20prominently%20displayed%2C%20multiethnic%20group%20including%20White%20blonde%20woman%2C%20African%20American%20man%2C%20Middle%20Eastern%20man%2C%20Asian%20woman%2C%20Hispanic%20woman%2C%20and%20Caucasian%20brunette%20man%20gathered%20around%20in%20stylish%20office%20lounge%2C%20diverse%20young%20professionals%20from%20all%20racial%20backgrounds%20including%20White%20people%20sharing%20snacks%20and%20conversation%2C%20modern%20corporate%20space%20with%20warm%20lighting%20and%20orange%20design%20elements%2C%20simple%20professional%20background&width=1920&height=1080&seq=hero-truly-diverse-vegoodies-logo-103&orientation=landscape'
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % heroImages.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        {heroImages.map((image, index) => (
          <img
            key={index}
            src={image}
            alt="VE Goodies Vending Solutions"
            className={`absolute inset-0 w-full h-full object-cover object-top transition-opacity duration-1000 ${
              index === currentImageIndex ? 'opacity-100' : 'opacity-0'
            }`}
          />
        ))}
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 text-center w-full">
        <div className="inline-flex items-center bg-orange-500/90 backdrop-blur-sm px-5 py-2 rounded-full shadow-lg mb-8 animate-pulse">
          <div className="w-5 h-5 flex items-center justify-center mr-2">
            <i className="ri-time-line text-white text-lg"></i>
          </div>
          <span className="text-sm font-bold text-white">Limited Time Offer - Act Now!</span>
        </div>

        <h1 className="text-6xl md:text-7xl lg:text-8xl font-bold text-white mb-8 leading-tight">
          Free Vending Machines<br />in Carrollton &amp;<br />Dallas-Fort Worth
        </h1>

        <p className="text-xl text-gray-200 mb-6 max-w-3xl mx-auto leading-relaxed">
          Transform your workplace with state-of-the-art vending machines featuring Coca-Cola, Pepsi, Frito-Lay, Doritos, Cheetos, Red Bull, Monster Energy, Gatorade, Dasani, Aquafina, and healthy snack options with cashless payment systems and 24/7 support across the Dallas-Fort Worth metroplex
        </p>

        <div className="bg-white/95 backdrop-blur-sm rounded-2xl p-6 max-w-2xl mx-auto mb-12 shadow-2xl">
          <div className="flex items-center justify-center mb-3">
            <div className="w-6 h-6 flex items-center justify-center mr-2">
              <i className="ri-checkbox-circle-fill text-orange-600 text-2xl"></i>
            </div>
            <p className="text-lg font-bold text-gray-900">
              No Cost Installation - Qualify Today!
            </p>
          </div>
          <p className="text-sm text-gray-600">
            Get started with zero upfront investment. Contact us now to see if your business qualifies for our no-cost vending machine placement program.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={() => scrollToSection('contact')}
            className="bg-gradient-to-r from-orange-500 to-orange-600 text-white px-10 py-5 rounded-full text-lg font-bold hover:from-orange-600 hover:to-orange-700 transition-all shadow-xl hover:shadow-2xl cursor-pointer whitespace-nowrap transform hover:scale-105"
          >
            Check Eligibility Now
          </button>
          <button
            onClick={() => scrollToSection('services')}
            className="text-white px-8 py-4 rounded-full text-base font-medium hover:text-orange-300 transition-colors border-b-2 border-white/50 hover:border-orange-300 cursor-pointer whitespace-nowrap"
          >
            View Services
          </button>
        </div>

        <div className="mt-8 flex items-center justify-center gap-6 text-white">
          <div className="flex items-center">
            <div className="w-5 h-5 flex items-center justify-center mr-2">
              <i className="ri-time-line text-orange-400 text-lg"></i>
            </div>
            <span className="text-sm font-medium">24/7 Support</span>
          </div>
          <div className="flex items-center">
            <div className="w-5 h-5 flex items-center justify-center mr-2">
              <i className="ri-shield-check-line text-orange-400 text-lg"></i>
            </div>
            <span className="text-sm font-medium">No Hidden Fees</span>
          </div>
          <div className="flex items-center">
            <div className="w-5 h-5 flex items-center justify-center mr-2">
              <i className="ri-rocket-line text-orange-400 text-lg"></i>
            </div>
            <span className="text-sm font-medium">Quick Setup</span>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-6 flex items-center justify-center">
          <i className="ri-arrow-down-line text-white text-2xl"></i>
        </div>
      </div>
    </section>
  );
}
